import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './loading/loading.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { LogoutComponent } from './logout/logout.component';
import { SafePipe } from '../utils/safe.pipe';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMenuModule } from '@angular/material/menu';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TncDialogComponent } from './tnc-dialog/tnc-dialog.component';
import { AnnotationComponent } from './annotation/annotation.component';
import { ImageUploadComponent } from './multimedia/image-upload/image-upload.component';
import { ImageCaptureComponent } from './multimedia/image-capture/image-capture.component';
import { WebcamModule } from 'ngx-webcam';
import { FaceCaptureComponent } from './multimedia/face-capture/face-capture.component';
import { FileUploadComponent } from './multimedia/file-upload/file-upload.component';
import { VideoUploadComponent } from './multimedia/video-upload/video-upload.component';
import { AudioUploadComponent } from './multimedia/audio-upload/audio-upload.component';
import { RecordTypeSelectorComponent } from './multimedia/record-type-selector/record-type-selector.component';
import { GalleryComponent } from './gallery/gallery.component';
import { OutsideclickDirective } from '../directives/outsideclick.directive';
import { AnnotationDialogUtilityComponent } from './annotation/annotation-dialog-utility/annotation-dialog-utility.component';
import { PinchZoomModule } from 'ngx-pinch-zoom';
import { WebcamComponent } from './multimedia/webcam/webcam.component';
import { CustomTooltipComponent } from './custom-tooltip/custom-tooltip.component';

@NgModule({
  declarations: [
    LoadingComponent,
    LogoutComponent,
    SafePipe,
    ConfirmDialogComponent,
    TncDialogComponent,
    AnnotationComponent,
    ImageUploadComponent,
    ImageCaptureComponent,
    FaceCaptureComponent,
    FileUploadComponent,
    VideoUploadComponent,
    AudioUploadComponent,
    RecordTypeSelectorComponent,
    GalleryComponent,
    OutsideclickDirective,
    AnnotationDialogUtilityComponent,
    WebcamComponent,
    CustomTooltipComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatProgressBarModule,
    MatMenuModule,
    MatTooltipModule,
    MatButtonModule,
    MatDialogModule,
    WebcamModule,
    MatRadioModule,
    MatCheckboxModule,
    PinchZoomModule
  ],
  exports: [
    LoadingComponent,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    SafePipe,
    LogoutComponent,
    MatProgressBarModule,
    MatMenuModule,
    ConfirmDialogComponent,
    MatTooltipModule,
    MatButtonModule,
    MatDialogModule,
    TncDialogComponent,
    AnnotationComponent,
    ImageUploadComponent,
    ImageCaptureComponent,
    FaceCaptureComponent,
    FileUploadComponent,
    AudioUploadComponent,
    VideoUploadComponent,
    GalleryComponent,
    OutsideclickDirective
  ]
})
export class SharedModule { }
